import i18n from '@/locales'
import axios from 'axios'
import { getLoginErrUriSSO, getLoginUriSSO } from '@/serves/api/signup'
import { pathUrl } from '@/config'
import { getToken, getLanguage } from './cache'
import { isEmbed } from '@/embed/env'
import embedBridge from '@/embed/bridge'

/**
 * 数组去重
 * @param {Array} arr
 * @returns {Array}
 */
export const unique = (arr) => {
  return Array.from(new Set(arr))
}
// 防抖
export function debounce(func, wait = 500, immediate = false) {
  let timeout
  return function () {
    const context = this
    const args = arguments

    const later = function () {
      timeout = null
      if (!immediate) {
        func.apply(context, args)
      }
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)

    if (callNow) {
      func.apply(context, args)
    }
  }
}

export const numberToChinese = (num) => {
  var AA = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十')
  var BB = new Array('', '十', '百', '仟', '萬', '億', '点', '')
  var a = ('' + num).replace(/(^0*)/g, '').split('.'),
    k = 0,
    re = ''
  for (var i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re
        break
      case 4:
        if (!new RegExp('0{4}//d{' + (a[0].length - i - 1) + '}$').test(a[0])) re = BB[4] + re
        break
      case 8:
        re = BB[5] + re
        BB[7] = BB[5]
        k = 0
        break
    }
    if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re
    if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re
    k++
  }

  if (a.length > 1) {
    // 加上小数部分(如果有小数部分)
    re += BB[6]
    for (let i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)]
  }
  if (re == '一十') re = '十'
  if (re.match(/^一/) && re.length == 3) re = re.replace('一', '')
  return re
}

//自主出题连词成句、看拼音写汉字转换方法解析初始数据字段为json
export const renderScreenText = (str) => {
  const xmlDoc = new DOMParser().parseFromString(str, 'text/xml')
  const chars = xmlDoc.querySelectorAll('font')
  if (!chars || chars.length == 0) {
    return [
      [
        {
          text: str,
          color: 'black',
          type: 'string', // 标识为纯字符串
        },
      ],
    ]
  }
  const color = chars[0].getAttribute('color')
  let index = 0
  let inputCount = -1
  let items = []
  items[0] = []
  for (let i = 0; i < chars.length; i++) {
    // 获取每个 <font> 标签的原始 HTML 内容并存储（展示文字拼音时需要）
    const fontHTML = chars[i].outerHTML
    if (chars[i].getAttribute('break')) {
      index++
      items[index] = new Array()
    }
    if (chars[i].textContent || chars[i].getAttribute('blank') === 'input') {
      if (chars[i].getAttribute('blank') === 'input') {
        inputCount++
      }
      let singObj = {
        text: chars[i].textContent,
        pinyin: chars[i].getAttribute('pinyin'),
        shengmu: chars[i].getAttribute('shengmu'),
        yunmu: chars[i].getAttribute('yunmu'),
        margin: chars[i].getAttribute('margin'),
        color: color == 'black' ? '#000' : chars[i].getAttribute('color'),
        break: chars[i].getAttribute('break'),
        blank: chars[i].getAttribute('blank'),
        width: chars[i].getAttribute('width'),
        pytext: fontHTML,
        index: inputCount,
      }
      if (singObj.pinyin !== null) {
        if (singObj.text === '儿' && !singObj.pinyin) {
          let pos = items[index].length
          items[index][pos - 1].text += '儿'
          items[index][pos - 1].color2 = singObj.color
        } else if (singObj.text === '儿' && singObj.pinyin === 'r') {
          let pos = items[index].length
          items[index][pos - 1].text += '儿'
          items[index][pos - 1].pinyin += 'r'
          items[index][pos - 1].color2 = singObj.color
        } else {
          items[index].push(singObj)
        }
      } else {
        items[index].push(singObj)
      }
    }
  }
  return items[0]
}

/**
 * 页面返回弹窗
 * @param {Function} callback // 回调
 * @param {String} type // 试题类型 process 流程式题型有结果页 cefr_test cefr水平测试
 * @param {String} msg // 提示消息
 * @param {Boolean} recordStatus // 是否有录音数据
 */
export const backLayerHandler = (
  callback,
  {
    type = 'default',
    msg = i18n.tc('hint_common_exit_tips_default'),
    recordStatus = false,
    cancel = () => {},
  } = {}
) => {
  if (type == 'process') {
    if (recordStatus) {
      msg = i18n.tc('hint_common_exit_tips_long')
    }
  }
  layer.open({
    title: '',
    closeBtn: 0,
    content: msg,
    btn: [i18n.tc('button_common_ok'), i18n.tc('button_common_cancel')],
    yes: (index) => {
      layer.close(index)
      callback(index)
    },
    btn2: (index) => {
      layer.close(index)
      cancel && cancel(index)
    },
  })
}

// 下载文件
export const uploadFile = ({ url, name = 'file' }) =>
  fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      const a = document.createElement('a')
      a.href = (window.URL || window.webkitURL).createObjectURL(blob)
      a.download = name
      a.rel = 'noopener noreferrer'
      a.click()
      URL.revokeObjectURL(a.href)
      a.remove()
    })
// 获取当前用户国家

export const getUserCountry = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('http://ip-api.com/json/')
      .then((res) => {
        resolve(res.data)
      })
      .catch((e) => reject(e))
  })
}
export const getQueryString = (name) => {
  // 获取url上的参数（使用decodeURIComponent对url参数进行解码）
  let search = decodeURIComponent(window.location.search).replace('?', '')
  const tempArr = search !== '' ? search.split('&') : []

  // 将参数名转小写，参数值保留原大小写
  tempArr.forEach((item) => {
    if (item) {
      const itemArr = item.split('=')
      search = search.replace(itemArr[0], itemArr[0].toLowerCase())
    }
  })

  // 正则匹配指定的参数
  const reg = new RegExp(`(^|&)${name.toLowerCase()}=([^&]*)(&|$)`)
  const result = search.match(reg)

  return result != null ? result[2] : ''
}

export const changeURLArg = (arg, arg_val) => {
  let url = window.location.href
  let pattern = arg + '=([^&]*)'
  let replaceText = arg + '=' + arg_val
  if (url.match(pattern)) {
    let tmp = '/(' + arg + '=)([^&]*)/gi'
    tmp = url.replace(eval(tmp), replaceText)
    return tmp
  } else {
    if (url.match('[?]')) {
      return url + '&' + replaceText
    } else {
      return url + '?' + replaceText
    }
  }
}
// 分钟转小时分钟
export const changeHourMinutes = (str) => {
  if (str !== '0' && str !== '' && str !== null) {
    return (
      (Math.floor(str / 60).toString().length < 2
        ? '0' + Math.floor(str / 60).toString()
        : Math.floor(str / 60).toString()) +
      ':' +
      ((str % 60).toString().length < 2 ? '0' + (str % 60).toString() : (str % 60).toString())
    )
  } else {
    return ''
  }
}

// json字符串转换为object
export const toJson = (str) => {
  if (typeof str == 'string') {
    try {
      const obj = JSON.parse(str)
      if (obj && typeof obj == 'object') {
        return obj
      } else {
        return str
      }
    } catch (error) {
      return str
    }
  } else {
    return str
  }
}

// 将object数据转换为字符串
export const toStr = (dt) => {
  if (typeof dt == 'string') {
    return dt
  } else if (typeof dt == 'object') {
    return JSON.stringify(dt)
  } else if (typeof dt == 'boolean') {
    return dt ? 'true' : 'false'
  } else if (typeof dt == 'number') {
    return dt.toString()
  } else {
    return dt
  }
}

// 强制弹框并跳转
export const forceToSSO = (errMsg) => {
  let l = window.layer
  let msg = errMsg || i18n.tc('log_in_error')
  l.alert(
    msg,
    {
      title: '',
      closeBtn: 0,
      btn: [i18n.tc('button_common_ok')],
    },
    (index) => {
      l.close(index)
      jumpToSSO(msg)
    }
  )
}
// 往 SSO 登录地址的 state（JSON）里合并字段，如 { mode: 'signup' }、joinCampus 的学校信息。
// state 不是 {...} 或解析失败时不再抛错：按空对象合并后追加 / 替换，保证「Create Account」这类入口总能跳过去
const hendleSSOUrlState = (url, obj) => {
  let state = {}
  let decodeUri = decodeURIComponent(url)
  const temp = decodeUri.match(/state=(\{.*\})/)
  if (temp) {
    try {
      state = JSON.parse(temp[1])
    } catch (e) {
      state = {}
    }
  }
  state = Object.assign(state, obj)
  const stateStr = 'state=' + JSON.stringify(state)
  if (temp) {
    decodeUri = decodeUri.replace(temp[0], stateStr)
  } else {
    decodeUri += (decodeUri.includes('?') ? '&' : '?') + stateStr
  }
  console.log('finishUri', encodeURI(decodeUri))
  return encodeURI(decodeUri)
}

// 给 SSO authorize URL 补上 lang，供 dulwich_sso_web 启动时读取（跨域无法共享 localStorage）
const appendSSOLangQuery = (url, lang) => {
  if (!url || !lang) return url
  try {
    const parsed = new URL(url)
    parsed.searchParams.set('lang', lang)
    return parsed.toString()
  } catch (e) {
    const sep = url.includes('?') ? '&' : '?'
    return `${url}${sep}lang=${encodeURIComponent(lang)}`
  }
}

// 判断跳转sso登录页
export const jumpToSSO = (forceJumpMsg,newStateObj) => {
  // 端内：绝不能把 WebView 导航到 SSO 域 —— 用户会在 App 里看到一个没有返回
  // 入口的网页登录页，登录完也回不到原页面。改为交给原生跳 App 自己的登录页。
  //
  // 保持"调用后页面必然被接管"的终态语义、不返回 true —— 返回 true 会让
  // router 的 `if (verified) next()` 在无 token 状态下继续渲染，首个接口立刻
  // 1001 → handleLogout → 又回到这里，形成自循环。
  if (isEmbed()) {
    console.log('端内模式，登录态失效，交由原生跳登录页')
    embedBridge.logout()
    return
  }

  console.log('进行sso登录跳转', forceJumpMsg)
  let queryActive_code = getQueryString('active_code')
  if (queryActive_code) {
    console.log('有 active_code 进行邮箱验证')
    return true
  }
  let code = getQueryString('code')
  let ticket = getQueryString('ticket')
  let l = window.layer
  if (code && ticket && !forceJumpMsg) {
    console.log('code && ticket 已存在 无法继续跳转')
    return
  }
  let SSOUrl = window.location.origin + window.location.pathname

  // let SSOUrl ='https://staging.hskmock.com' + window.location.pathname

  // if (process.env.VUE_APP_MODE == 'dev') {
  //   SSOUrl = pathUrl.MOCK
  // }
  let myApi = getLoginUriSSO
  if (forceJumpMsg) {
    myApi = getLoginErrUriSSO
  }
  // 把官网当前语言带给 SSO（query + state），避免 SSO 域沿用自己的旧 language 缓存
  const currentLang = getLanguage() || i18n.locale || 'en'
  myApi({
    redirect_uri: SSOUrl,
    lang: currentLang,
  })
    .then((res) => {
      let uri = res?.data?.url
      if (uri) {
        // if (process.env.VUE_APP_MODE == 'dev') {
        //   uri = uri.replace('https://staging-sso.hskmock.com', 'http://10.41.32.38:8081')
        //   uri += '&source=mock'
        // }
        // language 放最后，避免被 mode/joinCampus 等 state 字段覆盖；与 SSO getLocaleFromUrl 约定一致
        uri = hendleSSOUrlState(uri, { ...(newStateObj || {}), language: currentLang, lang: currentLang })
        uri = appendSSOLangQuery(uri, currentLang)
        // window.open(uri)
        console.log(uri)
        window.open(uri, '_self')
      } else {
        l.alert(
          i18n.tc('no_data'),
          {
            title: '',
            closeBtn: false,
            move: '.layui-layer-content',
            btn: ['ok'],
          },
          (index) => {
            l.close(index)
          }
        )
      }
    })
    .catch((err) => {
      console.log(err)
      l.alert(
        err?.message || err,
        {
          title: '',
          closeBtn: false,
          move: '.layui-layer-content',
          btn: ['ok'],
        },
        (index) => {
          l.close(index)
        }
      )
    })
  return false
}

// 跳转到sso登录页，获取code 然后跳转到汉考
export const jumpToHankao = (isDate) => {
  // if (process.env.VUE_APP_ENVIRONMENT !== 'china') {
  // 存在token 自己拼接URL
  let ssoUrl =
    process.env.VUE_APP_MODE === 'prod'
      ? process.env.VUE_APP_ENVIRONMENT === 'china'
        ? 'https://sso.hskmock.cn'
        : 'https://sso.hskmock.com'
      : process.env.VUE_APP_ENVIRONMENT === 'china'
      ? 'https://staging-sso.hskmock.cn'
      : 'https://staging-sso.hskmock.com'
  // if (process.env.VUE_APP_MODE == 'dev') {
  //   ssoUrl = 'http://10.41.32.17:8080'
  // }
  ssoUrl += '?jumpPath=' + (isDate ? 'date' : 'join')
  console.log('跳转sso：', ssoUrl)
  window.open(ssoUrl)
  // } else {
  //   window.open('https://www.chinesetest.cn/')
  // }
}

// 下载文件
export const downloadFile = (url, fileName) => {
  console.log('下载文件地址', url, fileName)
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.blob()
    })
    .then((blob) => {
      // 创建一个下载链接
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      // 设置链接的下载属性，可以指定保存的文件名
      if (fileName) link.download = fileName
      // 将链接添加到页面，并触发点击
      document.body.appendChild(link)
      link.click()
      // 移除链接
      document.body.removeChild(link)
    })
    .catch((error) => console.error('Error downloading image:', error))
}

// import XLSX from 'xlsx'
const XLSX = require('xlsx')

/**导出xlsx data :
 * @param data 导出的Excel所有分表数据
 * @param fileName Excel文件名 带后缀
 - [
 -   { sheet:'sheet1', data: {...}},
 -   { sheet:'sheet2', data: {...}},
 - ]
 * */
export const json2xlsx = (data, fileName) => {
  if (!XLSX || !data || !data.length) {
    return
  }

  console.log('version', XLSX.version)
  let book = XLSX.utils.book_new()
  // sheet1表示要导出的分区名字
  for (let i = 0; i < data.length; i++) {
    let sheet = XLSX.utils.json_to_sheet(data[i].data)
    XLSX.utils.book_append_sheet(book, sheet, data[i].sheet)
  }
  console.log('book', book.Sheets)
  if (!fileName) {
    fileName = `MyClass${new Date().getTime()}.xls`
  }
  XLSX.writeFile(book, fileName)
}

/**
 * 删除从'str1'到'str2'的所有字符。
 * @param {*} str 模板字符串
 * @param {*} arr 删除的收尾字符数组
 * @returns string
 */
export const removeStrBetween = (str, arr) => {
  let result = str
  if (result && arr.length) {
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i]
      if (element) {
        const start = element[0]
        const end = element[1]
        result = result.replace(new RegExp(`${start}(.*?)(${end}|$)`, 'g'), '')
      }
    }
  }
  return result
}

/**
 * 获取汉字文本的数量 不包括数字和英文
 * @param {*} str 文本字符串
 * @param {*} ex true表示剔除中文标点符号 默认不剔除中文标点
 * @returns
 */
export const getChineseWordsLength = (str, ex = false) => {
  if (!str || typeof str !== 'string') {
    return 0
  }
  var regex = ex ? /[\u4e00-\u9fa5]/g : /[\u4e00-\u9fa5\uff01-\uff60]/g // Unicode范围内的汉字 不包括标点
  let words = str.match(regex)
  // console.log('过滤后的汉字', words)
  return words.length
}

export const getAllWordsLength = (str) => {
  if (!str || typeof str !== 'string') {
    return 0
  }

  var regex = /[\s\n]/g
  let words = str.replace(regex, '')
  // console.log('过滤后的文本?', words)
  return words.length
}

export const transferLanguage = (transferStr) => {
    if (!transferStr) {
      return ''
    }
    let language = localStorage.getItem('language')
    if (language === 'zh') {
      language = 'cn'
  }
    return typeof transferStr === 'string' ? JSON.parse(transferStr)[language] : transferStr[language]
}

export function deepClone(data, hash = new WeakMap()) {
      if(typeof data !== 'object' || data === null){
            throw new TypeError('传入参数不是对象')
        }
      // 判断传入的待拷贝对象的引用是否存在于hash中
      if(hash.has(data)) {
            return hash.get(data)
        }
      let newData = {};
      const dataKeys = Object.keys(data);
      dataKeys.forEach(value => {
         const currentDataValue = data[value];
         // 基本数据类型的值和函数直接赋值拷贝
         if (typeof currentDataValue !== "object" || currentDataValue === null) {
              newData[value] = currentDataValue;
          } else if (Array.isArray(currentDataValue)) {
             // 实现数组的深拷贝
            newData[value] = [...currentDataValue];
          } else if (currentDataValue instanceof Set) {
             // 实现set数据的深拷贝
             newData[value] = new Set([...currentDataValue]);
          } else if (currentDataValue instanceof Map) {
             // 实现map数据的深拷贝
             newData[value] = new Map([...currentDataValue]);
          } else {
             // 将这个待拷贝对象的引用存于hash中
             hash.set(data,data)
             // 普通对象则递归赋值
             newData[value] = deepClone(currentDataValue, hash);
          }
       });
      return newData;
  }


